<div class="file-upload-container">
  <div class="file-upload-drop-zone"
       (drop)="dropFiles($event)"
       (dragover)='dragOverHandler($event)'
       (click)="fileInput.click()"
       (dragenter)="dropzoneHovered = true"
       (dragleave)="dropzoneHovered = false"
       [class.drag-active]="dropzoneHovered"
       [style.height]="heightInRem + 'rem'"
       [class.error]="error !== FileUploaderErrorsEnum.None"
  >
    <img class="icon-upload" src="assets/icons/icon-upload-file.svg" alt="upload-file-icon" />
    <span>{{dropFilesText}}</span><span class="link-word">{{link}}</span>
  </div>

  <input (click)="clearName()" (change)="afterFilesSelected($event)" class="file-input" type="file" #fileInput [multiple]="multiple" [accept]="accept"
  (cancel)="cancel($event)"/>
  <div [hidden]="error === FileUploaderErrorsEnum.None" 
    class="error-message">
    {{getErrorMessage()}}
  </div>
</div>
